module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"movie-count":"Featured movies","vip_badge":"VIP","svip_badge":"SVIP","annual_badge":"Annual","movie_count":"# Movies","no_movies":"You have no download history"},"ja":{"movie-count":"出演作品数","vip_badge":"VIP","svip_badge":"超VIP","annual_badge":"年間","movie_count":"出演作品数","no_movies":"ダウンロード履歴がありません"}}')
  delete Component.options._Ctor
}
